
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ShopList',
  props: {
    shops: {
      type: Array,
      default: () => [],
    },
    totalPagesCount: {
      type: Number,
      default: null,
    },
    currentPage: {
      type: [Number, String],
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
});
